module.exports = __webpack_public_path__ + "img/Comparison.b0b439f0.svg";